import Table from "react-bootstrap/Table";
import "../Styles/Admin.css";
import ActiveIcon from "../Assets/Icons/activeIcon.svg";
import InActiveIcon from "../Assets/Icons/inActiveIcon.svg";
import { Button } from "react-bootstrap";

export default function MerchantTable() {
  return (
    <Table style={{ textAlign: "center" }} hovered variant="light">
      <thead>
        <tr>
          <th
            style={{
              backgroundColor: "#E0E0E0",
              borderRadius: "6px 0px 0px 0px",
            }}
          >
            MERCHANT
          </th>
          <th style={{ backgroundColor: "#E0E0E0" }}>Email</th>
          <th style={{ backgroundColor: "#E0E0E0" }}>Country</th>
          <th style={{ backgroundColor: "#E0E0E0" }}>STATUS</th>
          <th
            style={{
              backgroundColor: "#E0E0E0",
              borderRadius: "0px 6px 0px 0px",
            }}
          >
            ACTION
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Naseem Muneer</td>
          <td>emial@email.com</td>
          <td>Pakistan</td>
          <td>
            <div style={{display: 'flex', alignItems: 'center', gap: '7px', justifyContent: 'center'}}>
                <img style={{marginTop: '1px'}} src={ActiveIcon} /> Active
            </div>
          </td>
          <td><Button style={{height: '1.625rem', fontSize:'0.70rem'}}>View</Button></td>
        </tr>
        <tr>
          <td>Naseem Muneer</td>
          <td>emial@email.com</td>
          <td>Pakistan</td>
          <td>
            <div style={{display: 'flex', alignItems: 'center', gap: '7px', justifyContent: 'center'}}>
                <img style={{marginTop: '1px'}} src={InActiveIcon} /> Inactive 
            </div>
          </td>
          <td><Button style={{height: '1.625rem', fontSize:'0.70rem'}}>View</Button></td>
        </tr>
        <tr>
          <td>Naseem Muneer</td>
          <td>emial@email.com</td>
          <td>Pakistan</td>
          <td>
            <div style={{display: 'flex', alignItems: 'center', gap: '7px', justifyContent: 'center'}}>
                <img style={{marginTop: '1px'}} src={ActiveIcon} /> Active
            </div>
          </td>
          <td><Button style={{height: '1.625rem', fontSize:'0.70rem'}}>View</Button></td>
        </tr>
        <tr>
          <td>Naseem Muneer</td>
          <td>emial@email.com</td>
          <td>Pakistan</td>
          <td>
            <div style={{display: 'flex', alignItems: 'center', gap: '7px', justifyContent: 'center'}}>
                <img style={{marginTop: '1px'}} src={InActiveIcon} /> Inactive
            </div>
          </td>
          <td><Button style={{height: '1.625rem', fontSize:'0.70rem'}}>View</Button></td>
        </tr>
        <tr>
          <td>Naseem Muneer</td>
          <td>emial@email.com</td>
          <td>Pakistan</td>
          <td>
            <div style={{display: 'flex', alignItems: 'center', gap: '7px', justifyContent: 'center'}}>
                <img style={{marginTop: '1px'}} src={ActiveIcon} /> Active
            </div>
          </td>
          <td><Button style={{height: '1.625rem', fontSize:'0.70rem'}}>View</Button></td>
        </tr>
      </tbody>
    </Table>
  );
}
